import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Grid, TableCell, TableRow } from '@mui/material';
import { Text } from 'components/text';
import React, { FC } from 'react';
import { History } from '../types';

type RowProps = {
  history: History,
};

export const Row: FC<RowProps> = ({
  history
}) => {
  return (
    <>
      <TableRow>
        <TableCell style={{ textAlign: "center", borderBottom: "none" }}>
          <Text value={history.version} color="primary" />
        </TableCell>
        <TableCell style={{
          overflow: "scroll",
          borderBottom: "none"
        }}
        >
          <Grid container>
            <Grid item style={{ overflow: "scroll", maxWidth: "800px" }}>
              <Box>
                <pre>{JSON.stringify(history.block, null, 2)}</pre>
              </Box>
            </Grid>
          </Grid>
        </TableCell>
        <TableCell style={{ textAlign: "center", borderBottom: "none" }}>
          {history.verified && (
            <FontAwesomeIcon icon="check-circle" size="2x" color="green" />
          )}
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{ textAlign: "center" }}>
          <Text value={history.version} color="primary" />
        </TableCell>
        <TableCell style={{
          overflow: "scroll"
        }}
        >
          <Grid container direction="column">
            <Grid item>
              <Text value="Data" color="primary" style={{ textAlign: "center", color: '#000000' }} fontWeight="500" />
            </Grid>
            <Grid item style={{ overflow: "scroll", maxWidth: "800px" }}>
              <Box>
                <pre>{JSON.stringify(history.data, null, 2)}</pre>
              </Box>
            </Grid>
          </Grid>
        </TableCell>
        <TableCell style={{ textAlign: "center" }}>
          {history.verified && (
            <FontAwesomeIcon icon="check-circle" size="2x" color="green" />
          )}
        </TableCell>
      </TableRow>
    </>
  );
};
